<template>
  <v-container>
    <v-row>
      <v-col>
        <div class="content-container">
          <div class="d-flex flex-wrap ga-2 justify-center justify-md-space-between align-center">
            <div class="account-container">
              <LoginInfos></LoginInfos>
            </div>
            <div class="module-title-container">
              <router-link :to="{ name: 'Home' }" style="text-decoration: none; color: inherit">
                <div class="text-h5 font-weight-bold text-center">{{ mainStore.module.evenement.nom }}</div>
              </router-link>
              <div class="text-h6 font-weight-bold text-center">{{ mainStore.module.readable_date }}</div>
            </div>
            <div>
              <StatusInscription></StatusInscription>
            </div>
          </div>
        </div>
        <NoticeInscriptionVIP v-if="mainStore.inscription_vip"></NoticeInscriptionVIP>
        <NoticeInscriptionAsAdmin v-if="mainStore.inscription_as_admin"></NoticeInscriptionAsAdmin>
        <NoticeInscriptionGroupe
          v-if="mainStore.bookingSystem.groupe.is_inscription_groupe && mainStore.bookingSystem.groupe.is_lien_groupe">
        </NoticeInscriptionGroupe>





      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import StatusInscription from "@/components/App/Header/Status_Inscription.vue";
import NoticeInscriptionVIP from "@/components/App/Header/NoticeInscriptionVIP.vue";
import NoticeInscriptionAsAdmin from "@/components/App/Header/NoticeInscriptionAsAdmin.vue";
import NoticeInscriptionGroupe from "@/components/App/Header/NoticeInscriptionGroupe.vue";
import LoginInfos from "@/components/Login/Login_Infos.vue";
import { useMainStore } from "@/stores/mainStore";
import { mapStores } from "pinia";

export default {
  components: { StatusInscription, LoginInfos, NoticeInscriptionVIP, NoticeInscriptionAsAdmin, NoticeInscriptionGroupe },
  data() {
    return {};
  },
  computed: {
    ...mapStores(useMainStore),
  },
};
</script>

<style lang="scss" scoped></style>